/*
 * testimonials — IO staggered fade-up for the social-proof grid. No GSAP.
 * Adds .testimonials--in when the section enters view; CSS does the staggered reveal.
 * Reduced-motion / no-IO -> reveal immediately. <noscript> reveals for no-JS.
 */
(function () {
  var roots = document.querySelectorAll('.testimonials');
  if (!roots.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window);
  roots.forEach(function (root) {
    if (reduce) { root.classList.add('testimonials--in'); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) { if (e.isIntersecting) { root.classList.add('testimonials--in'); obs.disconnect(); } });
    }, { threshold: 0.15 });
    io.observe(root);
  });
})();
